/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageemptytitle3Inputs */

const en_ticketpageemptytitle3 = /** @type {(inputs: Ticketpageemptytitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No orders yet`)
};

const de_ticketpageemptytitle3 = /** @type {(inputs: Ticketpageemptytitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bestellungen`)
};

/**
* | output |
* | --- |
* | "No orders yet" |
*
* @param {Ticketpageemptytitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageemptytitle3 = /** @type {((inputs?: Ticketpageemptytitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageemptytitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageemptytitle3(inputs)
	return de_ticketpageemptytitle3(inputs)
});
export { ticketpageemptytitle3 as "ticketPageEmptyTitle" }